module.exports = __webpack_public_path__ + "static/media/FreeDance_Low_Impact_Dance_Fitness_3.2d6f2ba8.webp";